import type { Address } from 'viem';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

import type { PerpsAgent } from '@/lib/hyperliquid/agent';

import { perpsUserKey } from './exchange';

export type PerpsSessionStore = {
  /** Missing means not loaded yet; null means this owner has no local agent. */
  agentsByUser: Record<string, PerpsAgent | null>;
  setAgent: (user: Address, agent: PerpsAgent | null) => void;
};

/** Browser-held signing sessions are separate from exchange snapshots and order drafts. */
export const usePerpsSessionStore = createWithEqualityFn<PerpsSessionStore>(
  (set) => ({
    agentsByUser: {},
    setAgent: (user, agent) =>
      set((state) => ({
        agentsByUser: { ...state.agentsByUser, [perpsUserKey(user)]: agent },
      })),
  }),
  shallow,
);

export const perpsAgentSelector = (user: Address | undefined) => (state: PerpsSessionStore) =>
  user ? state.agentsByUser[perpsUserKey(user)] : undefined;
